import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'feeTypeName',
    label: 'Fee - Prepaid Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'feeProviderId',
    label: 'Fee Provider',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerPaidAtClosingAmount',
    label: 'Borrower-Paid At Closing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerPaidBeforeClosingAmount',
    label: 'Borrower-Paid Before Closing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sellerPaidAtClosingAmount',
    label: 'Seller-Paid At Closing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sellerPaidBeforeClosingAmount',
    label: 'Seller-Paid Before Closing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'paidByOthersAmount',
    label: 'Paid By Others',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'financedAmount',
    label: 'Financed Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'recordingType',
    label: 'Recording Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hasInterestCredit',
    label: 'Interest Credit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'perDiem',
    label: 'Per Diem',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'total',
    label: 'Total',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'annualAmount',
    label: 'Prepaid Annual Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'months',
    label: 'Prepaid Months',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'totalCollected',
    label: 'Total Collected',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'totalImpounds',
    label: 'Total Impounds',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthsCushion',
    label: 'Months Cushion',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'aggregateAdjustment',
    label: 'Aggregate Adjustments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'impoundTypeId',
    label: 'Impound Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'frequency',
    label: 'Frequency',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'annualAmount',
    label: 'Impounds Annual Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyAmount',
    label: 'Monthly Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthsCollected',
    label: 'Impounds Months',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collectedAmount',
    label: 'Collected Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dueDate',
    label: 'Due Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'amountDue',
    label: 'Amount Due',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sellerAdjustmentTypeId',
    label: 'Adjustment Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'startDate',
    label: 'Start Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'endDate',
    label: 'End Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'totalAmount',
    label: 'Total Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cicFeeReasons',
    label: 'CIC Fee Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'amount',
    label: 'CIC Fee Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'name',
    label: 'Provider Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'contactPerson',
    label: 'Contact Person',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'contactPhone',
    label: 'Contact Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'licenseNumber',
    label: 'License Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'paidToType',
    label: 'Paid To Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'affiliate',
    label: 'Affiliate',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'addToServiceProviderList',
    label: 'Add To Service Provider List',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const feesForm = {
  name: FormNames.FEES,
  label: 'Fees',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
